import { el } from '../lib/dom'
import { createApiCard, createExamplePanel } from './apiCard'
import type { PageContext } from './types'

export type WorkbenchParts = {
  readonly editorHost: HTMLElement
  readonly notice: HTMLElement
  readonly stage: HTMLElement
  readonly budget: HTMLElement
  readonly watchButton: HTMLElement
  readonly saveButton: HTMLElement
  readonly status: HTMLElement
  readonly assistedBox: HTMLElement
  readonly replayHost: HTMLElement
}

/** Prompt on top, editor left, plot and actions right, replay underneath. Layout only. */
export const buildWorkbenchView = (ctx: PageContext, parts: WorkbenchParts): HTMLElement =>
  el(
    'section',
    { class: 'workbench', 'aria-labelledby': 'prompt-heading' },
    el('h1', { id: 'prompt-heading', class: 'prompt' }, ctx.prompt.text),
    el(
      'p',
      { class: 'prompt-sub' },
      'Type a draw() for a 64×64 plot. Every keystroke is recorded; the replay is what the town sees. ',
      ctx.me ? `You're ~${ctx.me.handle}.` : 'Log in with GitHub to save yours.',
    ),
    el(
      'div',
      { class: 'workbench-grid' },
      el(
        'div',
        { class: 'workbench-editor' },
        parts.editorHost,
        parts.notice,
        createExamplePanel(),
        createApiCard(),
      ),
      el(
        'div',
        { class: 'workbench-plot' },
        parts.stage,
        parts.budget,
        el('div', { class: 'actions' }, parts.watchButton, parts.saveButton),
        parts.status,
        el(
          'label',
          { class: 'assisted', for: 'assisted' },
          parts.assistedBox,
          ' Assisted input (dictation, IME). Shows tinted in replays, never penalised.',
        ),
      ),
    ),
    parts.replayHost,
  )

export const createPhoneNotice = (ctx: PageContext): HTMLElement =>
  el(
    'section',
    { class: 'workbench workbench-phone' },
    el('h1', { class: 'prompt' }, ctx.prompt.text),
    el(
      'p',
      { class: 'prompt-sub' },
      'Editing is desktop-only in Season 1. Replays play anywhere, so wander the list below.',
    ),
  )
